export function totalAmount(numbers: number[]): number {
    return numbers.reduce((acc, curr) => acc + curr, 0);
}

export function guestsNumber(numbers: number[]): number {
    return numbers.reduce((acc, curr) => acc + curr, 0);
}

export function findTotal(numbers: number[]): number {
    return numbers.reduce((acc, curr) => acc + curr, 0);
}


